module.exports = __webpack_public_path__ + "static/media/icon-right-arrow.0c766d08.svg";